import { useI18n, LANGS } from "../../i18n/useI18n";

export function LanguageSwitcher() {
  const { lang, setLang } = useI18n();
  return (
    <div className="flex items-center gap-1 rounded-full border border-slate-200 bg-white/70 p-1 text-xs">
      {LANGS.map((l) => (
        <button
          key={l}
          onClick={() => setLang(l)}
          aria-pressed={lang === l}
          className={`rounded-full px-2.5 py-1 font-medium uppercase transition-colors ${
            lang === l ? "bg-gold text-[#1A1405]" : "text-slate-500 hover:text-charcoal"
          }`}
        >
          {l}
        </button>
      ))}
    </div>
  );
}
